export const GET_ORGANIZATIONS = 'organizations/GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS_SUCCESS = 'organizations/GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILED = 'organizations/GET_ORGANIZATIONS_FAILED';